import React, { FC } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import getPageMetadata from 'config/seo';

export interface MetadataInterface {
  propTitle?: string;
  propDescription?: string;
}

const Metadata: FC<MetadataInterface> = ({ propTitle, propDescription }) => {
  const { pathname } = useRouter();
  const pageMetadata = getPageMetadata(pathname);
  const { title, description } = pageMetadata;
  const targetTitle = propTitle || title || '';
  const targetDescription = propDescription || description || '';
  return (
    <Head>
      <title>{targetTitle}</title>
      <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      <meta name="og:title" content={targetTitle} />
      <meta name="twitter:title" content={targetTitle} />
      <meta name="description" content={targetDescription} />
      <meta name="og:description" content={targetDescription} />
      <meta name="twitter:description" content={targetDescription} />
      {/*<meta property="image" content={metaImage} />*/}
      {/*<meta property="og:image" content={metaImage} />*/}
      {/*<meta name="twitter:image" content={metaImage} />*/}
      <meta name="twitter:card" content="summary" />
      <meta name="og:type" content="website" />
    </Head>
  );
};

export default Metadata;
